module["exports"] = [
  "Nederland"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/nl/address/default_country.js
 ** module id = 878
 ** module chunks = 0
 **/